import { Link, useNavigate } from 'react-router-dom';
import StorefrontLayout from './StorefrontLayout';
import { StudioImage } from '../studio/UI';
import { pieceName } from '../shopItems';
import { useCatalog } from '../catalogContext';
import '../css/App.css';

const Home = () => {
    const navigate = useNavigate();
    const { hachiokiItems } = useCatalog();
    window.scrollTo(0, 0);

    return (
        <StorefrontLayout>
            <main>
                <section className="homeHero">
                    <img
                        className="homeHeroBanner"
                        src="/images/hero-banner.png"
                        alt="はちおき — Hachioki"
                    />
                    <div className="homeHeroContent">
                        <button className="homeShopNow" onClick={() => navigate('/shop')}>
                            Shop now
                        </button>
                    </div>
                </section>

                <section className="collectionSection">
                    <div className="collectionImageRow">
                        {hachiokiItems.map((item) => {
                            const { name } = pieceName(item, { shop: true });
                            return (
                                <article className="collectionImageCard" key={item.id}>
                                    <Link className="collectionImageLink" to={`/products/${item.id}`}>
                                        <img src={item.image} alt={name} />
                                    </Link>
                                    <div className="collectionImageMeta">
                                        <Link className="collectionImageName" to={`/products/${item.id}`}>
                                            {name}
                                        </Link>
                                        <Link className="collectionHoverButton" to={`/products/${item.id}`}>
                                            View product
                                        </Link>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                    <Link className="homeArtIntro" to="/portfolio">
                        <StudioImage src="/studio/art-intro.webp" alt="Prints from the studio" sizes="(max-width: 1280px) 100vw, 1280px" width={1400} height={736} />
                        <span className="homeArtIntroOverlay">
                            <span className="homeArtIntroButton">View Portfolio</span>
                        </span>
                    </Link>
                    <div className="collectionFooter">
                        <p className="homeIntro">
                            Shop hand-pulled prints and designs. Every piece is printed by hand in small editions in San Diego, California.
                        </p>
                    </div>
                </section>
            </main>
        </StorefrontLayout>
    );
};

export default Home;
